import React from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';

import SmartImage from 'dpl/components/SmartImage';

export default function BreedHistorySectionPhotos() {
  const { overviewPageData } = useSelector(({ server }) => server);

  return (
    <div className="BreedHistorySectionPhotos dn db-l ph20">
      <div className="row wide-gutters">
        {overviewPageData.history_photos.map((photo, idx) => (
          <div
            key={idx}
            className={classnames('col-6', {
              pb20: idx === 0,
              pt20: idx === 1
            })}
          >
            <a
              href={photo.source_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <SmartImage src={photo.photo_url} alt={photo.alt_text} />
              {photo.source_name && (
                <div className="flex justify-end f2 br3 pt2 tr dark-silver">
                  Img:
                  <p className="ml1 underline">{photo.source_name}</p>
                </div>
              )}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
